<div class="position-relative">
  <input
    type="text"
    #dateInput
    #popover="ngbPopover"
    autocomplete="off"
    class="datepicker-input"
    [disabled]="disabled"
    [class.review-input-error-border]="error"
    [class.calendar-open]="showingDatePicker$ | async"
    [attr.id]="controlId"
    [value]="displayValue$ | async"
    [container]="'body'"
    [triggers]="'manual'"
    [animation]="false"
    [autoClose]="false"
    [ngbPopover]="datePicker"
    [popoverClass]="'date-picker-popover'"
    [maskito]="maskitoOptions"
    [placeholder]="placeholder"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (focus)="onFocus()" />
  <button
    type="button"
    class="no-style-button datepicker-input-button"
    [disabled]="disabled"
    (click)="openDatePicker()">
    <img [src]="inputIconSrc$ | async" alt="open datepicker" i18n-alt />
  </button>
</div>

<ng-template #datePicker>
  <app-datepicker-input-calendar
    [dateRange]="false"
    [isStartDate]="true"
    [initialSelectedDates]="selectedFormattedDates$ | async"
    [minDate]="minDate$ | async"
    [maxDate]="maxDate$ | async"
    (dateSelected)="onDateSelected($event)" />
</ng-template>
